import { styled, useTheme } from "@mui/material";
import type { ComponentProps, CSSProperties } from "react";

const SvgScopedContainer = styled("div")({
  display: "block",
  position: "relative",
  width: "fit-content",
  "@keyframes maraLoaderBounce": {
    "0%, 80%, 100%": {
      transform: "translateY(0)",
      opacity: 0.5,
    },
    "40%": {
      transform: "translateY(-10px)",
      opacity: 1,
    },
  },
});

interface MaraLoaderProps
  extends Omit<ComponentProps<typeof SvgScopedContainer>, "width"> {
  width?: CSSProperties["width"];
}

export function MaraLoader({
  width = "fit-content",
  style,
  ...props
}: MaraLoaderProps) {
  const theme = useTheme();

  return (
    <SvgScopedContainer {...props} style={{ width, ...style }}>
      <svg viewBox="0 0 120 60" width="100%" height="auto">
        <title>Mara Loader</title>
        <rect
          width="60"
          height="30"
          y="50%"
          rx="5"
          fill={theme.palette.support[100]}
        />
        <rect
          width="120"
          height="60"
          rx="30"
          fill={theme.palette.support[100]}
        />
        <circle
          cx="30"
          cy="32"
          r="8"
          fill={theme.palette.secondary.dark}
          style={{
            animation: "maraLoaderBounce 1.2s ease-in-out infinite",
            animationDelay: "0s",
          }}
        />
        <circle
          cx="60"
          cy="32"
          r="8"
          fill={theme.palette.secondary.dark}
          style={{
            animation: "maraLoaderBounce 1.2s ease-in-out infinite 0.15s",
          }}
        />
        <circle
          cx="90"
          cy="32"
          r="8"
          fill={theme.palette.secondary.dark}
          style={{
            animation: "maraLoaderBounce 1.2s ease-in-out infinite 0.3s",
          }}
        />
      </svg>
    </SvgScopedContainer>
  );
}
